export { default } from "./getArticleCategory";
